import React from "react";
import { H4 } from "../../AbstractElements";
import { Link } from "react-router-dom";
import InvoiceActionCell from "../../Components/Billing/invoice/ActionCell";
import CompanyActionCell from "../../Components/Companies/companies/CompanyActionCell";

export const TempDataColumns = [
  {
    name: <H4>Sl No</H4>,
    selector: (row) => row.Si,
    sortable: true,
    width: "70px",
    center:true,
  },
  {
    name: <H4>Name</H4>,
    selector: (row) => row.Name,
    sortable: true,
    width: "170px",
    wrap: true,
  },
  {
    name: <H4>Email</H4>,
    selector: (row) => row.Email,
    sortable: true,
    width: "230px",
    wrap: true,
  },
  {
    name: <H4>Phone No</H4>,
    selector: (row) =>   "+" + row.CountryCode + row.Mobile_Number,
    sortable: true,
    width: "170px",
    wrap: true,
  },
  {
    name: <H4>Industry Name</H4>,
    selector: (row) => row.Industry,
    sortable: true,
    width: "150px",
    wrap: true,
  },
    {
    name: <H4>Company Name</H4>,
    selector: (row) => row.Company,
    sortable: true,
    width: "150px",
    wrap: true,
  },
   {
    name: <H4>Created Date</H4>,
    selector: (row) => row.CreateDate,
    sortable: true,
    width: "150px",
    wrap: true,
  },
  {
    name: <H4>State</H4>,
    selector: (row) => row.State,
    sortable: true,
    width: "150px",
    wrap: true,
  },
  {
    name: <H4>Country</H4>,
    selector: (row) => row.Country,
    sortable: true,
    width: "100px",
    wrap: true,
  },
  
];

export const TraialDataColumns = (redirectTopackage) => [
  {
    name: <H4>Sl No</H4>,
    cell: (row, index) => index + 1,
    sortable: true,
    width: "70px",
  },
  {
    name: <H4>Name</H4>,
    selector: (row) => row.user_name,
    sortable: true,
    width: "170px",
    wrap: true,
  },
  {
    name: <H4>Email</H4>,
    selector: (row) => row.email,
    sortable: true,
    width: "230px",
    wrap: true,
  },
  {
    name: <H4>Phone No.</H4>,
    selector: (row) => "+" + row.country_code + row.mobile,
    sortable: true,
    width: "170px",
    wrap: true,
  },
  {
    name: <H4>Industry</H4>,
    selector: (row) => row.industry_name,
    sortable: true,
    width: "150px",
    wrap: true,
  },
  {
    name: <H4>Company</H4>,
    selector: (row) => row.company_name,
    sortable: true,
    width: "150px",
    wrap: true,
  },
  {
    name: <H4>Company Id</H4>,
    selector: (row) => row.company_id,
    sortable: true,
    width: "150px",
    wrap: true,
  },
  {
    name: <H4>State</H4>,
    selector: (row) => row.state,
    sortable: true,
    width: "150px",
    wrap: true,
  },
  {
    name: <H4>Country</H4>,
    selector: (row) => row.country,
    sortable: true,
    width: "100px",
    wrap: true,
  },
  {
    name: <H4>Action</H4>,
    cell: (row) => (
      <button
        className="btn btn-primary mb-2 mt-2 ms-2"
        onClick={() => redirectTopackage(row)}
      >
        Renew
      </button>
    ),
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,
    width: "150px",
  },
  {
    name: <i className="fa fa-gears" style={{ fontSize: "15px" }}></i>,
    selector: (row) => row.action,
    cell: (row) => <ActionCell row={row} />,
    center: true,
    width: "55px",
  },
];
export const SubscriptionUserColumns = [
  {
    name: <H4>Sl No</H4>,
    selector: (row) => row.Si,
    sortable: true,
    center: true,
    width: "80px",
  },
  {
    name: <H4>Company</H4>,
    selector: (row) => (
      <Link
        to={`${process.env.PUBLIC_URL}/subscriptions/companyProfile?id=${row.CompanyId}&user_id=${row.userId}&industryId=${row.IndustryId}`}
        state={{
          clientUrl: row.clientUrl,
          industryName: row.IndustryName,
        }}
      >{row.CompName}</Link>),
    sortable: true,
    center: true,
    wrap: true,
  },
  {
    name: <H4>Plan</H4>,
    selector: (row) => row.PackName,
    sortable: true,
    center: true,
    wrap: true,
  },
  {
    name: <H4>Start Date</H4>,
    selector: (row) => row.StartDate,
    sortable: true,
    center: true,
    wrap: true,
  },
  {
    name: <H4>End Date</H4>,
    selector: (row) => row.EndDate,
    sortable: true,
    center: true,
    wrap: true,
  },
  {
    name: <H4>Activation Status</H4>,
    selector: (row) => row.Status,
    sortable: true,
    // center: true,
    cell: (row) => (
      <span className={`badge badge-${row.Status}`}>{row.Status}</span>
    ),
  },
];
export const SubscriptionCompanyColumns = [
  {
    name: <H4>Sl No</H4>,
    selector: (row) => row.Si,
    sortable: true,
    center: true,
    width: "80px",
  },
  // {
  //     name: <H4>Company</H4>,
  //     selector: row => row.CompName,
  //     sortable: true,
  //     center: true,
  //     wrap: true
  // },
  {
    name: <H4>Plan</H4>,
    selector: (row) => row.PackName,
    sortable: true,
    // center: true,
    wrap: true,
  },
  {
    name: <H4>Start Date</H4>,
    selector: (row) => row.StartDate,
    sortable: true,
    // center: true,
    wrap: true,
  },
  {
    name: <H4>End Date</H4>,
    selector: (row) => row.EndDate,
    sortable: true,
    // center: true,
    wrap: true,
  },
  {
    name: <H4>Activation Status</H4>,
    selector: (row) => row.Status,
    sortable: true,
    // center: true,
    cell: (row) => (
      <span className={`badge badge-${row.Status}`}>{row.Status}</span>
    ),
  },
];
export const PaymentColumns = [
  {
    name: <H4>Sl No</H4>,
    selector: (row) => row.Si,
    sortable: true,
    width: "70px",
    center:true
  },
  {
    name: <H4>User Name</H4>,
    selector: (row) => (
      <Link
        to={`${process.env.PUBLIC_URL}/subscriptions/company-list/userProfile?id=${row.user_id}`}
      >
        {row.Name}
      </Link>
    ),
    sortable: true,
    width: "110px",
    wrap: true,
  },
  {
    name: <H4>User Id</H4>,
    selector: (row) => (
      <Link
        to={`${process.env.PUBLIC_URL}/subscriptions/company-list/userProfile?id=${row.user_id}`}
      >
        {row.user_id}
      </Link>
    ),
    sortable: true,
    width: "110px",
    wrap: true,
  },
  {
    name: <H4>Invoice No</H4>,
    selector: (row) => row.Invoice_no,
    cell: (row) => {
      return (
        <Link
          to={`${process.env.PUBLIC_URL}/companies/company-list/userProfile/invoice?&order_id=${row.order_id}`}
        >
          {row.Invoice_no}
        </Link>
      );
    },

    sortable: true,
    width: "120px",
    wrap: true,
  },
  
  {
    name: <H4>Txn Id</H4>,
    selector: (row) => row.Txn_id,
    sortable: true,
    width: "170px",
    wrap: true,
  },
  {
    name: <H4>Industry</H4>,
    selector: (row) => row.Industry,
    sortable: true,
    width: "120px",
    wrap: true,
  },
   {
        name: <H4>Company Name</H4>,
        selector: (row) => (
          <Link
            to={`${process.env.PUBLIC_URL}/subscriptions/companyProfile?id=${row.Company_id}&user_id=${row.user_id}&industryId=${row.industryTypeId}`}
            state={{
              clientUrl: row.client_url,
              industryName: row.Industry,
            }}
          >
            {row.Company_name}
          </Link>
        ),
        sortable: true,
        width: "190px",
        wrap: true,
      },
   {
    name: <H4>Company Id</H4>,
    id: "company_name",
    selector: (row) => row.Company_id,
    sortable: true,
    width: "150px",
    wrap: true,
  },
  {
    name: <H4>Payment Method</H4>,
    selector: (row) => row.Payment_method,
    sortable: true,
    width: "150px",
    wrap: true,
  },
  {
    name: <H4>Date</H4>,
    selector: (row) => row.Date,
    sortable: true,
    width: "150px",
    wrap: true,
  },
  {
    name: <H4>Amount</H4>,
    selector: (row) => (
      <span className=" fw-bolder billerq_color">₹ {row.Amount}</span>
    ),
    sortable: true,
    width: "100px",
    wrap: true,
  },
  {
    name: <H4>Status</H4>,
    selector: (row) => row.Status,
    cell: (row) => (
      <span className={`badge badge-${row.Status}`}>{row.Status}</span>
    ),

    sortable: true,
    width: "80px",
    wrap: true,
  },
];

export const InvoiceDataColumns = (viewForm, refreshInvoice, setLoading,roleId) => [
  {
    name: <H4>Sl No</H4>,
    selector: (row) => row.Si,
    sortable: true,
    width: "80px",
    wrap: true,
    center:true
  },
  
  roleId === 1 && {
    name: <H4>Action</H4>,
    cell: (row) => (
      <InvoiceActionCell
        row={row}
        viewForm={viewForm}
        refreshInvoice={refreshInvoice}
        setLoading={setLoading}
      />
    ),
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,
  },
  {
    name: <H4>Payment Status</H4>,
    id: "payment_status",
    selector: (row) => row.Payment_status,
    sortable: true,
    width: "90px",
    wrap: true,
    cell: (row) => (
      <span className={`badge badge-${row.Payment_status}`}>
        {row.Payment_status}
      </span>
    ),
  },
   {
    name: <H4>User Name</H4>,
    id: "user_name",
    selector: (row) => (
      <Link
        to={`${process.env.PUBLIC_URL}/subscriptions/company-list/userProfile?id=${row.User_id}`}
      >
        {row.User_name}
      </Link>
    ),
    sortable: true,
    width: "150px",
    wrap: true,
  },
 {
        name: <H4>Company Name</H4>,
        selector: (row) => (
          <Link
            to={`${process.env.PUBLIC_URL}/subscriptions/companyProfile?id=${row.company_id}&user_id=${row.User_id}&industryId=${row.industryTypeId}`}
            state={{
              clientUrl: row.client_url,
              industryName: row.Industry,
            }}
          >
            {row.Company_name}
          </Link>
        ),
        sortable: true,
        width: "190px",
        wrap: true,
      },
    {
    name: <H4>Industry Name</H4>,
    id: "industry_name",
    selector: (row) => row.Industry_name,
    sortable: true,
    width: "150px",
    wrap: true,
  },

  {
    name: <H4>Invoice No</H4>,
    id: "invoice_number",
    selector: (row) => (
      <Link
        to={`${process.env.PUBLIC_URL}/companies/company-list/userProfile/invoice?id=${row.User_id}&order_id=${row.Id}`}
      >
        {row.Invoice_no}
      </Link>
    ),
    sortable: true,
    width: "100px",
    wrap: true,
  },
    {
    name: <H4>Amount</H4>,
    id: "amount",
    selector: (row) => (
      <span className=" fw-bolder billerq_color">₹ {row.Amount}</span>
    ),
    sortable: true,
    width: "110px",
    wrap: true,
  },
  {
    name: <H4>Balance</H4>,
    id: "balance",
    selector: (row) => (
      <span className=" fw-bolder billerq_color">₹ {row.Balance}</span>
    ),
    sortable: true,
    width: "110px",
    wrap: true,
  },
  {
    name: <H4>Invoiced Date</H4>,
    id: "invoice_date",
    selector: (row) => row.Invoiced_at,
    sortable: true,
    width: "130px",
    wrap: true,
  },
  
  {
    name: <H4>Invoiced Type</H4>,
    id: "invoice_date",
    selector: (row) => row.InvoiceType,
    sortable: true,
    width: "130px",
    wrap: true,
  },
 

  // {
  //     name: <H4>Status</H4>,
  //     id: 'order_status',
  //     selector: row => row.Status,
  //     sortable: true,
  //     width: '90px',
  //     wrap: true,
  //     cell: row => (
  //         <span
  //             className={`badge badge-${row.Status}`}
  //         >
  //             {row.Status}
  //         </span>
  //     ),
  // },
  {
    name: <H4>Extend Due Days</H4>,
    id: "skip_due",
    selector: (row) => row.Expire_days,
    sortable: true,
    width: "150px",
    wrap: true,
  },
].filter(Boolean);

export const CompanyColumns = (industryUserData, deleteCompanyList,roleId) => [
  {
    name: <H4>Sl No</H4>,
    selector: (row) => row.Si,
    sortable: true,
    width: "70px",
     center: true,
  },
 
  roleId == 1&& {
    name: <i className="fa fa-gears" style={{ fontSize: "15px" }}></i>,
    selector: (row) => row.action,
    cell: (row) => (
      <CompanyActionCell
        row={row}
        deleteCompany={deleteCompanyList}
        companyData={industryUserData}
      />
    ),
    center: true,
    width: "55px",
  },
  {
    name: <H4>Company Name</H4>,
    selector: (row) => (
      <Link
        to={`${process.env.PUBLIC_URL}/subscriptions/companyProfile?id=${row.CompanyId}&user_id=${row.id}&industryId=${row.IndustryId}`}
        state={{
          clientUrl: row.client_url,
          industryName: row.Industry,
        }}
      >
        {row.Company}
      </Link>
    ),
    sortable: true,
    width: "190px",
    wrap: true,
  },
  {
    name: <H4>Company Id</H4>,
    selector: (row) => (
      <Link
        to={`${process.env.PUBLIC_URL}/subscriptions/companyProfile?id=${row.CompanyId}&user_id=${row.id}&industryId=${row.IndustryId}`}
        state={{
          clientUrl: row.client_url,
          industryName: row.Industry,
        }}
      >
        {row.CompanyId}
      </Link>
      ),
    sortable: true,
    width: "120px",
    wrap: true,
  },
  {
    name: <H4>User Name</H4>,
    selector: (row) => (
      <Link
        to={`${process.env.PUBLIC_URL}/subscriptions/company-list/userProfile?id=${row.id}`}
      >
        {row.Name}
      </Link>
    ),
    sortable: true,
    width: "190px",
    wrap: true,
  },
  {
    name: <H4>User Id</H4>,
    selector: (row) => (
      <Link
        to={`${process.env.PUBLIC_URL}/subscriptions/company-list/userProfile?id=${row.id}`}
      >
        {row.id}
      </Link>
    ),
    sortable: true,
    width: "110px",
    wrap: true,
  },

  {
    name: <H4>Phone No</H4>,
    selector: (row) => "+" + row.Mobile,
    sortable: true,
    width: "150px",
    wrap: true,
  },
  {
    name: <H4>Industry Name</H4>,
    selector: (row) => row.Industry,
    sortable: true,
    width: "190px",
    wrap: true,
  },
  {
    name: <H4>Package</H4>,
    selector: (row) => row.Package,
    sortable: true,
    width: "100px",
    wrap: true,
  },
  {
    name: <H4>Plan Type</H4>,
    selector: (row) => row.planType,
    sortable: true,
    width: "100px",
    wrap: true,
  },
  {
    name: <H4>Start Date</H4>,
    selector: (row) => row.StartDate,
    sortable: true,
    width: "130px",
    wrap: true,
  },
  {
    name: <H4>End Date</H4>,
    selector: (row) => row.EndDate,
    sortable: true,
    width: "130px",
    wrap: true,
  },
    {
    name: <H4>Email</H4>,
    selector: (row) => row.Email,
    sortable: true,
    width: "190px",
    wrap: true,
  },
  {
    name: <H4>SMS</H4>,
    selector: (row) => row.Sms ?? "No Credits",
    cell: (row) => {
      const value = row.Sms ?? "No Credits";
      return (
        <span className={`badge badge-${value === "No Credits" ? "secondary" : value}`}>
          {value}
        </span>
      );
    },
    sortable: true,
    width: "100px",
    wrap: true,
  },
  {
    name: <H4>Whatsapp</H4>,
    selector: (row) => row.WhatsApp ?? "No Credits",
    cell: (row) => {
      const value = row.WhatsApp ?? "No Credits";
      return (
        <span className={`badge badge-${value === "No Credits" ? "secondary" : value}`}>
          {value}
        </span>
      );
    },
    sortable: true,
    width: "100px",
    wrap: true,
  },
  
{
  name: <H4>Payment Status</H4>,
  id: "payment_status",
  selector: (row) =>
    row.planType === "free" ? "Free" : row.PayamentStatus,
  sortable: true,
  width: "150px",
  center: true,
  wrap: true,
  cell: (row) => {
    const status =
      row.planType === "free" ? "free" : row.PayamentStatus;
    return (
      <span className={`badge badge-${status}`}>
        {status}
      </span>
    );
  },
},
  {
    name: <H4>Payment Settings</H4>,
    selector: (row) => row.DemandPay,
    cell: (row) => (
      <span className={`badge badge-${row.DemandPay === 1 ? "active" : "suspended"}`}>
        {row.DemandPay === 1 ? "Enabled" : "Disabled"}
      </span>
    ),
    sortable: true,
    width: "160px",
    center: true,
    wrap: true,
  },
  {
    name: <H4>Status</H4>,
    selector: (row) => row.Status,
    cell: (row) => (
      <span className={`badge badge-${row.Status}`}>{row.Status}</span>
    ),
    sortable: true,
    width: "80px",
    wrap: true,
  },
].filter(Boolean);;
export const PaymntColumns = [
  {
    name: <H4>Sl No</H4>,
    selector: (row) => row.Si,
    sortable: true,
    center: false,
    width: "80px",
  },
  {
    name: <H4>Action</H4>,
    selector: (row) => row.Action,
    sortable: true,
  },
  {
    name: <H4>Date</H4>,
    selector: (row) => row.Date,
    sortable: true,
    center: false,
  },
  {
    name: <H4>Amount</H4>,
    selector: (row) => row.Amount,
    sortable: true,
    center: false,
  },
  {
    name: <H4>Transaction Id</H4>,
    selector: (row) => row.TransactionId,
    sortable: true,
    center: false,
  },
  // {
  //     name: <H4>Account</H4>,
  //     selector: row => row.Account,
  //     sortable: true,
  //     center: false,
  // },
  {
    name: <H4>Description</H4>,
    selector: (row) => row.Description,
    sortable: true,
    center: false,
  },
  {
    name: <H4>Reference</H4>,
    selector: (row) => row.Ref,
    sortable: false,
    center: true,
  },
].filter(Boolean);
export const paymentsColumns = [
  {
    name: <H4>Sl No</H4>,
    selector: (row) => row.Si,
    sortable: true,
    width: "80px",
    center: true,
  },
  {
    name: <H4>Action</H4>,
    selector: (row) => row.Action,
    sortable: true,
    // center: true,
  },
  // {
  //     name: <H4>Company</H4>,
  //     selector: row => row.CompName,
  //     sortable: true,
  //     // center: true,
  // },
  {
    name: <H4>Paid On</H4>,
    selector: (row) => row.Paidat,
    sortable: true,
    // center: true,
    wrap: true,
  },
  {
    name: <H4>Txn Id</H4>,
    selector: (row) => row.txnId,
    sortable: true,
    // center: true,
    wrap: true,
  },
  {
    name: <H4>Amount Collected</H4>,
    selector: (row) => row.Amount,
    sortable: true,
    // center: true,
    wrap: true,
    width: "120px",
  },
  {
    name: <H4>Industry Name</H4>,
    selector: (row) => row.IndustryName,
    sortable: true,
    center: true,
    width: "165px",
    wrap: true,
  },
  {
    name: <H4>Payment Type</H4>,
    selector: (row) => row.payType,
    sortable: true,
    center: true,
  },
  {
    name: <H4>Status</H4>,
    selector: (row) => row.Status,
    sortable: true,
    center: true,
    width: "135px",
  },
];
